const SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 64C0 28.7 28.7 0 64 0H224V224H0V64zM0 288H224V512H64C28.7 512 0 483.3 0 448V288zM288 0H448C483.3 0 512 28.7 512 64V224H288V0zM288 288H512V448C512 483.3 483.3 512 448 512H288V288z"/></svg>';
export default SVG;
